/* ============================================================
   Scorpelli — Premium Motion Layer (JS)
   Auto-applies scroll-reveal to sections/cards without requiring
   per-block editor configuration. No-ops if reduced motion is set.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function markRevealTargets() {
    // Whole sections reveal as a unit
    document.querySelectorAll('.shopify-section:not(.pm-scanned)').forEach(function (section) {
      section.classList.add('pm-scanned', 'pm-reveal');
    });

    // Individual product cards get their own staggered reveal
    var cards = document.querySelectorAll('[class*="product-card"]:not(.pm-scanned)');
    cards.forEach(function (card, i) {
      card.classList.add('pm-scanned', 'pm-reveal', 'pm-reveal-child');
      card.style.setProperty('--pm-index', i % 8);
    });
  }

  function observe() {
    var targets = document.querySelectorAll('.pm-reveal:not(.pm-observed)');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('pm-visible', 'pm-observed'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pm-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    targets.forEach(function (t) {
      t.classList.add('pm-observed');
      io.observe(t);
    });
  }

  function run() {
    markRevealTargets();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-scan after Shopify section rendering (theme editor, infinite scroll, AJAX cart, etc.)
  document.addEventListener('shopify:section:load', run);

  var rescanTimer;
  var mo = new MutationObserver(function () {
    clearTimeout(rescanTimer);
    rescanTimer = setTimeout(run, 200);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
